require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.index-of");

function e(e) {
  return e && "object" == typeof e && "default" in e ? e["default"] : e;
}

var n = e(require("react")),
    t = e(require("prop-types"));

function r(e) {
  return "fast" === e ? 600 : "slow" === e ? 900 : 750;
}

var i = function i(e) {
  var t = e.color,
      i = e.speed,
      a = e.gap,
      s = e.thickness,
      o = e.size,
      c = function (e, n) {
    var t = {};

    for (var r in e) {
      Object.prototype.hasOwnProperty.call(e, r) && -1 === n.indexOf(r) && (t[r] = e[r]);
    }

    return t;
  }(e, ["color", "speed", "gap", "thickness", "size"]);

  return n.createElement("svg", Object.assign({}, {
    height: o,
    width: o
  }, c, {
    style: {
      animationDuration: r(i) + "ms"
    },
    className: "__react-svg-spinner_circle",
    role: "img",
    "aria-labelledby": "title desc",
    viewBox: "0 0 32 32"
  }), n.createElement("title", {
    id: "title"
  }, "Circle loading spinner"), n.createElement("desc", {
    id: "desc"
  }, 'Image of a partial circle indicating "loading."'), n.createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "\n      .__react-svg-spinner_circle{\n          transition-property: transform;\n          animation-name: __react-svg-spinner_infinite-spin;\n          animation-iteration-count: infinite;\n          animation-timing-function: linear;\n      }\n      @keyframes __react-svg-spinner_infinite-spin {\n          from {transform: rotate(0deg)}\n          to {transform: rotate(360deg)}\n      }\n    "
    }
  }), n.createElement("circle", {
    role: "presentation",
    cx: 16,
    cy: 16,
    r: 14 - s / 2,
    stroke: t,
    fill: "none",
    strokeWidth: s,
    strokeDasharray: 2 * Math.PI * (11 - a),
    strokeLinecap: "round"
  }));
};

i.propTypes = {
  color: t.string,
  thickness: t.oneOf([1, 2, 3, 4, 5, 6, 7, 8]).isRequired,
  gap: t.oneOf([1, 2, 3, 4, 5]).isRequired,
  speed: t.oneOf(["fast", "slow"]),
  size: t.string.isRequired
}, i.defaultProps = {
  color: "rgba(0,0,0,0.4)",
  gap: 4,
  thickness: 4,
  size: "1em"
}, module.exports = i;